import { TFunction } from "i18next";
import { DCRecord } from "@/@types/lib/dataController";

export function pathFormat(obj: DCRecord, format: string) {
  let keys = Object.keys(obj);

  if (format) {
    let label = format;
    if (keys.length > 0) {
      keys.forEach((k) => {
        const key = k as keyof DCRecord;
        let re = new RegExp('{' + k + '}');
        label = label.replace(re, obj[key] != null ? obj[key] as string : '');
      })
      return label;
    } else {
      return null;
    }
  } else {
    return keys.map(x => {
      const xkey = x as keyof DCRecord;
      return obj[xkey] as string;
    }).join(', ');
  }
}